export default __webpack_public_path__ + "static/media/kwid-gallery-1.2eefa676.jpg";